export const FILE_UPLOAD_IMAGES_ALLOWED_MIME_TYPES =
  "image/png, image/jpeg, image/bmp";

export const FILE_UPLOAD_IMAGES_MAX_FILE_SIZE = 4 * 1024 * 1024;
